import { NodeViewProps } from '@tiptap/react';
import React, { useRef } from 'react';
import ImageResizeMenu from './ImageResizeMenu';
import Popper from '@mui/material/Popper';

export interface useImagePopMenuProps {
  anchorRef: React.RefObject<HTMLDivElement>;
  updateAttributes: NodeViewProps['updateAttributes'];
  deleteNode: NodeViewProps['deleteNode'];
}

export function useImagePopMenu({
  anchorRef,
  updateAttributes,
  deleteNode,
}: useImagePopMenuProps) {
  const poppoverHideDelayRef = useRef<ReturnType<typeof setTimeout>>();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    clearTimeout(poppoverHideDelayRef.current);
    setAnchorEl(anchorRef.current);
  };

  const handlePopoverClose = () => {
    poppoverHideDelayRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 500);
  };
  const open = Boolean(anchorEl);
  const handleAlignLeft = () => {
    updateAttributes({ justify: 'flex-start', float: 'none' });
  };
  const handleAlignCenter = () => {
    updateAttributes({ justify: 'center', float: 'none' });
  };
  const handleAlignRight = () => {
    updateAttributes({ justify: 'flex-end', float: 'none' });
  };
  const handleWrapLeft = () => {
    updateAttributes({ justify: undefined, float: 'left' });
  };
  const handleWrapRight = () => {
    updateAttributes({ justify: undefined, float: 'right' });
  };
  const handleDelete = () => {
    deleteNode();
  };
  const ImagePopMenu = () => (
    <Popper
      id="mouse-over-popover"
      open={open}
      anchorEl={anchorEl}
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
      popperOptions={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 20],
            },
          },
        ],
      }}
    >
      <ImageResizeMenu
        onAlignCenter={handleAlignCenter}
        onAlignLeft={handleAlignLeft}
        onAlignRight={handleAlignRight}
        onWrapLeft={handleWrapLeft}
        onWrapRight={handleWrapRight}
        onDelete={handleDelete}
      />
    </Popper>
  );

  return {
    ImagePopMenu,
    handlePopoverOpen,
    handlePopoverClose,
    open,
    anchorEl,
  };
}
